// Vouchers
export const SVS_CODE_LENGTH = 19;
export const SVS_CODE_INDICATOR = '600649';
export const FUEL_VOUCHER_CODES = {
  FUEL_1: 'FUEL1',
  FUEL_2: 'FUEL2',
};
export const AMEXBCE_PROMO_CODE = 'AMEXBCE15';
export const GIADA_PROMO_CODES = ['GAPRTGIADA', 'GIADAHP'];

export const TEMPO_PLAN_MEALS_PER_WEEK = [6, 8, 10, 12, 14, 16];

export const PICK_YOUR_MEALS_MINIMUM_ITEMS = 12;

// Local Storage Keys
export const SHOW_PROMO_BANNER_LOCAL_STORAGE = 'showPromoBanner';
export const PICK_MEALS_SELECTIONS_MENU_ID_LOCAL_STORAGE = 'pickYourMealsSelectionsMenuId';
export const INTRO_SMS_OPT_IN = 'introSmsOptIn';

// User Statuses
export const Statuses = {
  PICK_PLAN_STEP: 'on_plans_step',
  DIETARY_PREFERENCES_STEP: 'on_preference_dietary_step',
  DIETARY_AVOID_STEP: 'on_preference_avoid_step',
  PROMO_STEP: 'on_promo_step',
  BOX_PEOPLE_STEP: 'on_box_people_step',
  BOX_STEP: 'on_build_a_box_step',
  BILLING_STEP: 'on_billing_step',
  THANK_YOU_STEP: 'on_thankyou_step',
  FUNNEL_COMPLETE: 'funnel_complete',
  FUNNEL_COMPLETE_PICK_MEALS: 'funnel_complete_pick_meals',
  PICK_MEALS_STEP: 'on_pick_meals_step',
  PICK_MEALS_BILLING_STEP: 'on_pick_meals_billing_step',
  PICK_MEALS_THANK_YOU_STEP: 'on_pick_meals_thank_you_step',
};

export const SKIP_PATHS = {
  INTRO: 'toIntro',
  PREF_DIETARY: 'toPreferencesDietary',
  PROMO: 'toPromo',
  BOX_PEOPLE: 'toBoxPeople',
  BOX: 'toBox',
  BILLING: 'toBilling',
  THANK_YOU: 'toThankYou',
  PICK_MEALS: 'toPickMeals',
  PICK_MEALS_BILLING: 'toPickMealsBilling',
  PICK_MEALS_THANK_YOU: 'toPickMealsThankYou',
};

// Partnerships
export const SPONGEBOB = 'spongebob';
export const AYESHA_CURRY = 'ayesha-curry';
export const PEPPA_PIG = 'peppa pig';
export const GABBY = "Gabby's Dollhouse";
export const PEPPA_GIFT = 'Peppa Pig';
export const GABBY_GIFT = "Gabby's Dollhouse: The Movie";
export const TMNT = 'Teenage Mutant Ninja Turtles';

export const PARTNERSHIP_RESOURCE_TYPES = {
  LOGO: 'logo',
  MEAL_IMAGE: 'meal_image',
  BADGE: 'badge',
  INTRO_IMAGE: 'intro_image',
};

// Box Recommender Questions Subheader
export const BOX_QUESTIONS = {
  'box-people': {
    homechef_subheader:
      'This helps us suggest a number of servings for your meals. Change this at any time!',
    tempo_subheader:
      'This helps us suggest a number of meals for your box. Change this at any time!',
  },
  'box-meals': {
    homechef_subheader: 'This helps us suggest meals for your box. Change this at any time!',
    tempo_subheader: 'This helps us suggest meals. Change this any time!',
  },
  'box-days': {
    subheader: 'This helps us suggest a number of meals for your box. Change this at any time!',
  },
};

// Mealtimes Icons
export const DESSERTS = 'Desserts';
export const DINNERS = 'Dinners';
export const LUNCHES = 'Lunches';
export const BREAKFASTS = 'Breakfasts';
export const SNACKS_AND_BEVERAGES = 'Snacks & Beverages';

export const BOX_MEALS_SIGNUP_ANSWERS = [
  DINNERS,
  LUNCHES,
  DESSERTS,
  BREAKFASTS,
  SNACKS_AND_BEVERAGES,
];

// Box Recommender Paths
export const BOX_RECOMMENDER_PATHS = {
  BOX_PEOPLE: 'box-people',
  BOX_MEALS: 'box-meals',
  BOX_DAYS: 'box-days',
};

// Long Pause Verification
export const LONG_PAUSE_VERIFICATION_REQUIRED_KEY = 'hc_long_pause_verification_required';

export const HEROES_REFERRER = 'heroesReferrer';
